
import React, { useState, useEffect, useCallback, forwardRef, useMemo } from 'react';
import { Grid, Typography, Icon } from '@mui/material';
import TableView from '../../../../../../../components/TableView'//'Components/TableView';
import Checkbox from 'Components/Checkbox';
import moment from 'moment';

// International
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { MenuComponent } from 'Components/Menu';
import {Timezone} from '../../../../../../../components/uiControls';
import { Tooltip } from 'Components';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import StopCircleIcon from '@mui/icons-material/StopCircle'; //stop
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder'; //watch
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation'; // calendar
import RoomIcon from '@mui/icons-material/Room';
import AssistantPhotoIcon from '@mui/icons-material/AssistantPhoto';
import SpeedIcon from '@mui/icons-material/Speed';
import { speedFormatMPH } from '../../../../../../../core/data/Helpers';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import './vehicleTrails.scss'
import { Expand } from '@mui/icons-material';
import { isArray } from 'lodash';

import { TypeLayer } from '../../../../../../../components/Map/providers/enums'//'Components/Map/providers/enums'
import { eventsWithoutSpeed } from 'Components/Map/utils';
import { translateEvent } from '../../../../../../.common/utils/translateEvents';
import { OemDataButton } from 'Modules/.common/components/OemDataModal';

// Progressive rendering: render items in batches to avoid blocking the main thread
const INITIAL_BATCH = 20;
const BATCH_SIZE = 30;



const VehicleTrailList = forwardRef((props, ref) => {

    const { data, onClickItem, mapRef, className, prefSettings, onItemSelected, paramItemSelected, oemUnit } = props
    const { messages } = useIntl();


    const speedOverrideActions = [
        messages['edit'],
        messages['delete']
    ];

    const consolidateEvents = [
        {event: 'Drive', name: messages['event_drive']},
        {event: 'Travel Start', name: messages['event_travel_start']},
        {event: 'Motion', name: messages['event_motionevent']},
        {event: 'Motion Start', name: messages['event_motionstart']}
    ];

    const [itemSelected, setItemSelected] = useState(0)
    const [itemExpand, setItemExpand] = useState(null)
    const [markersVisibles, setMarkersVisibles] = useState([])

    const valueItemSelected = paramItemSelected ? paramItemSelected : itemSelected

    const dispatch = useDispatch();

    const timeZone = useSelector((state) => state.securityRedux.user.timeZone);
    const isKph = useSelector((state) => state.securityRedux.user.isKph);
    const locale = useSelector(state => state.commomRedux.language);
    const idClickMarkerTrails = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.idClickMarkerTrails);

    // Progressive rendering: only render a subset of items initially, then grow
    const [visibleCount, setVisibleCount] = useState(INITIAL_BATCH);

    useEffect(() => {
        // Reset visible count when data changes
        setVisibleCount(INITIAL_BATCH);
    }, [data]);

    useEffect(() => {
        if (data && visibleCount < data.length) {
            const timer = requestAnimationFrame(() => {
                setVisibleCount((prev) => Math.min(prev + BATCH_SIZE, data.length));
            });
            return () => cancelAnimationFrame(timer);
        }
    }, [visibleCount, data]);

    const visibleData = useMemo(() => {
        if (!data) return [];
        return data.slice(0, visibleCount);
    }, [data, visibleCount]);

    const onChangePage = useCallback((paramPage) => {
        //not implement this event
    }, []);

    useEffect(()=> {
        if(idClickMarkerTrails != null){
            //select the card //set the color gray        
            onItemSelected ? onItemSelected(idClickMarkerTrails) : setItemSelected(idClickMarkerTrails);

            //create the vehicle trails history -- display the points on map
            mapRef?.current?.removeLayer(TypeLayer.VehicleTrailsTrailHistory);
            //get row element
            const row = data?.find((x) => x?.id == idClickMarkerTrails);
            if(isArray(row?.trail) && row?.trail?.length > 0){
                mapRef.current.drawHistoryTrailOnMap(row.trail)
            }
        }
    },[idClickMarkerTrails])

    const onSelectCard = (row) => {
        onClickItem(row)

        //create the vehicle trails history
        mapRef.current.removeLayer(TypeLayer.VehicleTrailsTrailHistory);
        if(isArray(row.trail) && row.trail.length > 0){
            mapRef.current.drawHistoryTrailOnMap(row.trail)
        }

        if(valueItemSelected && row.id == valueItemSelected){
            onItemSelected ? onItemSelected(0) : setItemSelected(0)
        }else{
            onItemSelected ? onItemSelected(row.id) : setItemSelected(row.id)
        }
    }

    const onExpand = (row) => {
        onSelectCard(row)
        setItemExpand(row)

        mapRef.current.updateMarkersVisible(markersVisibles, false)
        
        //add the markers to the group on the map
        if(row?.children?.length > 0){
            const arrayIdsMarkers = row.children.map((item) => item.id.toString())
            setMarkersVisibles(arrayIdsMarkers)
            mapRef.current.updateMarkersVisible(arrayIdsMarkers, true);
        }

        if(prefSettings?.trailShowWaypointNumbers){
            mapRef.current.addLabelMarkers(TypeLayer.VehicleTrails, true)
        }
    }

    const onCollapse = () => {
        mapRef.current.updateMarkersVisible(markersVisibles, false)
        if(prefSettings?.trailShowWaypointNumbers){
            mapRef.current.addLabelMarkers(TypeLayer.VehicleTrails, true)
        }
        setItemExpand(null)
    }

    const nameEvent = (findNameEvent, isLightMetric, row) => {
        if (findNameEvent) {
            return findNameEvent.name;
        } else {
            const name = row?.name;

            // If name already has custom label (mapped in createDataToShow), return it directly
            if (name && name !== row?.eventName && !/^Input\s*\d+\s*(On|Off)$/i.test(name)) {
                return name;
            }

            const baseName = name?.split(' - ')[0];
            const translatedEvent = translateEvent(row?.eventName, messages);

            if (isLightMetric) {
            return baseName === row?.eventName
                ? `${translatedEvent}` || ''
                : `${baseName} - ${translatedEvent}` || '';
            } else {
            return baseName === row?.eventName
                ? `${translatedEvent}` || ''
                : `${baseName} - ${translatedEvent}` || '';
            }
        }
    };

    return(
        
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                ref={ref}
            >
                    {
                        (visibleData && visibleData.length > 0) && 
                        visibleData.map((row) => {
                            const isLightMetric = row?.unitType === "lightmetric"
                            const findNameEvent = row?.children?.length > 0 ? consolidateEvents.find(item => item.event == row?.eventName) : null

                        return (
                            <div key={row?.id} id={`item-${row?.id}`} style={{ padding: '10px 15px 10px 2px' }}>
                                <div className={row?.id == valueItemSelected ? `${className ? className : ' vehicle-trail-list-card '} vehicle-trail-list-container-selected ` : `${className ? className : ' vehicle-trail-list-card '} vehicle-trail-list-container `}>
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                    >
                                        <Grid item>
                                            <PlayCircleIcon style={{ color: row?.color, padding: 2 }} />
                                        </Grid>
                                        <Grid item xs zeroMinWidth style={{  padding: '0px 0px 4px 8px' }}>
                                            <Typography
                                                noWrap
                                                variant="subtitle1"
                                                className="vehicle-trail-list-title"
                                                onClick={() => onSelectCard(row)}
                                            >
                                                {nameEvent(findNameEvent, isLightMetric, row)}
                                            </Typography>
                                        </Grid>
                                        {
                                            oemUnit &&
                                            <Grid item>
                                                <OemDataButton
                                                    variant="icon"
                                                    unitId={row?.deviceId || oemUnit.id}
                                                    eventId={row?.id}
                                                    manufacturerName={oemUnit.manufacturerName}
                                                    unitLabel={oemUnit.label}
                                                />
                                            </Grid>
                                        }
                                        {
                                            (row?.children?.length > 0 && (!itemExpand || (itemExpand && itemExpand?.id != row?.id))) &&  
                                           <Grid>
                                                <KeyboardArrowDownIcon style={{ zIndex: 4 }} onClick={()=>{
                                                    onExpand(row)}}
                                                />
                                            </Grid>
                                        }
                                        {
                                            (itemExpand && itemExpand?.id == row?.id) &&
                                            <Grid>
                                                <KeyboardArrowUpIcon style={{ zIndex: 4 }} onClick={()=>{
                                                    onCollapse()}}
                                                />
                                            </Grid>
                                        }
                                    </Grid>

                                    {
                                    
                                    row?.children?.length > 0
                                    ?
                                    <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                            onClick={() => onSelectCard(row)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <Grid item xs zeroMinWidth>
                                                <div style={{display: 'flex', flexWrap: 'nowrap'}}>
                                                    <QueryBuilderIcon style={{ color: 'gray', padding: 2, fontSize: 18 }} /> 
                                                    <Tooltip title={messages['event_totaltime']}>
                                                        <Typography className="vehicle-trail-list-subtitle" noWrap variant="subtitle2" color={row?.id == valueItemSelected ? 'inherit' : ''}>
                                                            {moment.utc(row?.totalDurationOnSpeed).format('HH:mm:ss')}
                                                        </Typography>
                                                    </Tooltip>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    :
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                            onClick={() => onSelectCard(row)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <Grid item xs={7} zeroMinWidth>
                                                <div style={{display: 'flex', flexWrap: 'nowrap'}}>
                                                    <QueryBuilderIcon style={{ color: 'gray', padding: 2, fontSize: 18 }} /> 
                                                    <Typography className="vehicle-trail-list-subtitle" noWrap variant="subtitle2" color={row?.id == valueItemSelected ? 'inherit' : ''}>
                                                        <Timezone
                                                            date={new Date(row?.unitTime)}
                                                            dateFormat={""}
                                                            timeFormat="hh:mm:ss a"
                                                            timezone={row?.vehicleTimezone}
                                                            className="labelTrailDate"
                                                            customFormat={true}
                                                            locale={locale}
                                                            noWrap={false}
                                                            oneControl={true}
                                                        />
                                                    </Typography>
                                                </div>
                                            </Grid>
                                            <Grid item xs={5} zeroMinWidth>
                                                <div style={{display: 'flex', flexWrap: 'nowrap'}}>
                                                    <InsertInvitationIcon style={{ color: 'black', padding: 2, fontSize: 18 }} /> 
                                                    <Typography className="vehicle-trail-list-subtitle" noWrap variant="subtitle2" color={row?.id == valueItemSelected ? 'inherit' : ''}>
                                                        {row?.formatedTime}
                                                    </Typography>
                                                </div>
                                            </Grid>                                            
                                        </Grid>
                                    }

                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        onClick={() => onSelectCard(row)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <Grid item xs zeroMinWidth>
                                            <div style={{display: 'flex', flexWrap: 'nowrap'}}>
                                                <RoomIcon style={{ color: 'black', padding: 2, fontSize: 18 }} /> 
                                                {
                                                    (row?.address?.length > 32)
                                                    ?
                                                    <Tooltip title={row?.address}>
                                                        <Typography className="vehicle-trail-list-subtitle" noWrap variant="subtitle2" color={row?.id == valueItemSelected ? 'inherit' : ''}>
                                                            {row?.address}
                                                        </Typography>
                                                    </Tooltip>
                                                    :
                                                    <Typography className="vehicle-trail-list-subtitle" noWrap variant="subtitle2" color={row?.id == valueItemSelected ? 'inherit' : ''}>
                                                        {row?.address}
                                                    </Typography>
                                                }
                                            </div>
                                        </Grid>
                                    </Grid>

                                    {
                                        row?.children?.length > 0 && 
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                            onClick={() => onSelectCard(row)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <Grid item xs zeroMinWidth>
                                                <div style={{display: 'flex', flexWrap: 'nowrap'}}>
                                                    <RoomIcon style={{ color: 'black', padding: 2, fontSize: 18 }} /> 
                                                    {
                                                        (row?.finalAddress?.length > 32)
                                                        ?
                                                        <Tooltip title={row?.finalAddress}>
                                                            <Typography className="vehicle-trail-list-subtitle" noWrap variant="subtitle2" color={row?.id == valueItemSelected ? 'inherit' : ''}>
                                                                {row?.finalAddress}
                                                            </Typography>
                                                        </Tooltip>
                                                        :
                                                        <Typography className="vehicle-trail-list-subtitle" noWrap variant="subtitle2" color={row?.id == valueItemSelected ? 'inherit' : ''}>
                                                            {row?.finalAddress}
                                                        </Typography>
                                                    }
                                                </div>
                                            </Grid>
                                        </Grid>
                                    }

                                    {
                                        row?.children?.length > 0 ?
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                            onClick={() => onSelectCard(row)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <Grid item xs={6} zeroMinWidth>
                                                <div style={{width: '100%'}}></div>
                                            </Grid>
                                            <Grid item xs={6} zeroMinWidth>
                                                <div style={{display: 'flex', flexWrap: 'nowrap'}}>
                                                    <SpeedIcon style={{ color: 'black', padding: 2, fontSize: 18 }} /> 
                                                    <Tooltip title={row?.maxOverSpeed ? messages['event_overspeed'] : messages['event_maxspeed_one']  }>
                                                        <Typography 
                                                            /* className="vehicle-trail-list-subtitle" */ noWrap 
                                                            variant="subtitle2"
                                                            color={row?.maxOverSpeed > 0 ? '#ED2020' : '#2AAC30'}
                                                            style={{ textTransform: 'lowercase', paddingRight: 4, fontSize: 15 }}
                                                        >
                                                            {`${row?.maxOverSpeed ? '+' + speedFormatMPH(row?.maxOverSpeed, row?.unitType, isKph, true) : speedFormatMPH(row?.maxSpeed, row?.unitType, isKph, true)}`}
                                                        </Typography>
                                                    </Tooltip>
                                                </div>
                                            </Grid>
                                        </Grid>
                                        :
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                            onClick={() => onSelectCard(row)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <Grid item xs={7} zeroMinWidth>
                                                <div style={{ display: 'flex', flexWrap: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    {row?.landmarkObject}
                                                </div>
                                            </Grid>
                                            <Grid item xs={5} zeroMinWidth>
                                                <div style={{display: 'flex', flexWrap: 'nowrap'}}>
                                                    <SpeedIcon style={{ color: 'black', padding: 2, fontSize: 18 }} /> 
                                                    <Typography 
                                                        /* className="vehicle-trail-list-subtitle" */ noWrap 
                                                        variant="subtitle2"
                                                        color={row.postedSpeedColor}
                                                        style={{ textTransform: 'lowercase', paddingRight: 4, fontSize: 15 }}
                                                    >
                                                        {`${row?.speed ? speedFormatMPH(row?.speed, row?.unitType, isKph, true, true) : 0}`}
                                                    </Typography>
                                                    {
                                                    !eventsWithoutSpeed.includes(row?.eventName)
                                                    &&
                                                    <Typography 
                                                        className="vehicle-trail-list-subtitle" noWrap 
                                                        variant="subtitle2" 
                                                        color={'black'}
                                                        style={{ 
                                                            textTransform: 'lowercase',
                                                            fontSize: 14,
                                                            padding: '3px 0px 2px 0px', // Añade un espacio alrededor del texto para que el borde no quede justo alrededor del número
                                                            border: '1px solid black', // Crea un borde sólido de 2px en color negro
                                                            width: 16,
                                                            height: 12,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginTop: 2
                                                        }}
                                                    >
                                                        {`${row.speedLimit ? speedFormatMPH(row?.speedLimit, row?.unitType, isKph, true, true) : '?'}`}
                                                    </Typography>
                                                    }
                                                    <Typography 
                                                        className="vehicle-trail-list-subtitle" noWrap 
                                                        variant="subtitle2" 
                                                        color={'black'}
                                                        style={{ textTransform: 'lowercase', paddingLeft: 4 }}
                                                    >
                                                        {`${isKph ? 'kph' : 'mph'}`}
                                                    </Typography>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    }
                                    
                                </div>
                                { (row?.children?.length > 0 && (!itemExpand || (itemExpand && itemExpand?.id != row?.id))) && <div className="small-card"></div> }
                                { (row?.children?.length > 0 &&  (!itemExpand || (itemExpand && itemExpand?.id != row?.id))) && <div className="small-card-second"></div> }
                                {
                                    
                                    (itemExpand && row?.id == itemExpand?.id) 
                                    && 
                                        <div style={{    
                                            paddingLeft: 3
                                        }} >
                                            <VehicleTrailList 
                                                className='vehicle-trail-list-car-child' 
                                                data={itemExpand?.children} 
                                                onClickItem={onClickItem} 
                                                mapRef={mapRef} 
                                                onItemSelected={setItemSelected} 
                                                paramItemSelected={valueItemSelected}
                                            >
                                            </VehicleTrailList>
                                        </div>
                                }                            
                            </div>
                        )
                    })
                }
            </Grid>
    )

});


export default VehicleTrailList;